import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

// Libraries
import moment from "moment/moment";





export default function InProgressOrders() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [orders, setOrders] = useState([]);





    useEffect(() => {

        let date = moment().format("YYYY-MM-DD");

        // Load the order details
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/?showOpen=true`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("ordered today:", res.data);
                setOrders(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });


    }, [])

    



    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                            <h1>In Progress Orders</h1>

                          

                            <table style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 120 }}>Order No.</th>
                                        <th>Date</th>
                                        <th>Customer</th>
                                        <th>Agent</th>
                                        <th style={{ width: 100 }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>Net Contribution</th>
                                        <th style={{ width: 140 }}>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orders && (orders.map((order) => {
                                        return (
                                            <tr key={order.id} style={{ cursor: "pointer" }}>
                                                <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.id}</td>
                                                <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{moment(order.dateOrdered).format('DD/MM/YYYY')}</td>
                                                <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.customer.name} {order.farm && `(${order.farm})`}</td>
                                                <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.agent.name}</td>
                                                <td onClick={() => { navigate(`/Orders/View/${order.id}`) }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{order.totalNetContribution.toFixed(2)}</td>

                                                <td>
                                                    <Link to={`/Orders/View/${order.id}`} className="btn-sm btn-primary">View</Link>
                                                    <Link to={`/Orders/Edit/${order.id}`} className="btn-sm btn-other">Edit</Link>
                                                </td>
                                            </tr>
                                        )
                                    }))}

                                </tbody>
                            </table>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
